module.exports = __webpack_public_path__ + "static/media/marketing.272a1680.svg";